import { Trans, useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import {
	DTicketPauseSubscriptionIcon,
	EMlpIconTypes,
	EMplVariantTypes,
	MplButton,
	MplIconMessage,
	MplModal,
} from '@mopla/ui';

interface IDTicketPauseConfirmationModalProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	activeFrom: string;
	isLoading?: boolean;
}

const transComponents = {
	b: <Typography variant="b2-m" component="span" color="primary.main" />,
};

export const DTicketPauseConfirmationModal = ({
	open,
	onConfirm,
	onCancel,
	activeFrom,
	isLoading = false,
}: IDTicketPauseConfirmationModalProps) => {
	const { t } = useTranslation('dticketSubscriptionPause');

	const infoMessage = (
		<Trans
			t={t}
			i18nKey="confirmation_modal.info_message"
			values={{ date: activeFrom }}
			components={transComponents}
		/>
	);

	const modalContent = (
		<Stack spacing={2} sx={{ textAlign: 'left' }}>
			<MplIconMessage
				type={EMlpIconTypes.Info}
				variant={EMplVariantTypes.Info}
				message={infoMessage}
				dataTestid="dticket-pauseConfirmationModal-info-iconMessage"
			/>

			<Typography variant="b2" color="primary.main">
				{t('confirmation_modal.description_1')}
			</Typography>

			<Typography variant="b2" color="primary.main">
				{t('confirmation_modal.description_2')}
			</Typography>
		</Stack>
	);

	return (
		<MplModal
			open={open}
			testId="DTicketSubscriptionPause-ConfirmationModal"
			icon={<DTicketPauseSubscriptionIcon />}
			title={t('confirmation_modal.title')}
			textAlign="left"
			content={modalContent}
			isLoading={isLoading}
			buttons={
				<>
					<MplButton
						variant="contained"
						color="primary"
						fullWidth
						onClick={onConfirm}
						testId="dticket-pauseConfirmationModal-confirm-button"
					>
						{t('confirmation_modal.confirm_button')}
					</MplButton>
					<MplButton
						variant="outlined"
						fullWidth
						onClick={onCancel}
						testId="dticket-pauseConfirmationModal-cancel-button"
					>
						{t('confirmation_modal.cancel_button')}
					</MplButton>
				</>
			}
		/>
	);
};
